import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexjson from './edit.json';
import { CiImageOn } from "react-icons/ci";
import advancejson from '@vayu-blocks/advance-panel/advance.json';

registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson, ...advancejson},
	edit: Edit,
	icon: <CiImageOn  style={{color:'#6c1bc3'}} />,
	save,
});